import { useEditor, useNode } from "@craftjs/core";
import { ReactNode } from "react";

interface TextContainerProps {
    children: ReactNode;
}

const StepTextContainer = ({ children }: Partial<TextContainerProps>) => {
    const {
        connectors: { connect },
    } = useNode();

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    if (enabled && !children)
        return (
            <div ref={(ref) => connect(ref!)} className="w-full p-3 bg-gray-200 rounded animate-pulse">
                This is an empty text container, start dropping 'paragraph' elements here to get started!
            </div>
        );

    return (
        <div ref={(ref) => connect(ref!)} className="flex flex-col gap-6">
            {children}
        </div>
    );
};

export default StepTextContainer;

StepTextContainer.craft = {
    displayName: "Container",
    rules: {
        canDrag: () => true,
        canMoveOut: () => true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canDrop: (targetNode: any, currentNode: any) =>
            currentNode.data.name === "StepParagraph" ||
            targetNode.data.name === "FilterContainer" ||
            targetNode.data.name === "ContentContainer",
    },
};
